export enum MemberProjectsTabEnum {
    favorite = 0,
    active = 1,
    locked = 2
}
